// same code as useObjectCount.ts in crm-import-wizard-lib
// https://git.hubteam.com/HubSpot/crm-import-ui/blob/cbb1ae3bb3293190e2354838823500e347e16bce/crm-import-wizard-lib/static/js/AppSettings/hooks/useObjectCount.ts

import { useQuery } from 'data-fetching-client';
import { GET_OBJECT_COUNT } from '../query/objectDataCountQuery';
function useObjectCount({
  objectTypeId
}) {
  const {
    loading,
    error,
    data
  } = useQuery(GET_OBJECT_COUNT, {
    variables: {
      objectTypeId
    }
  });
  return {
    count: data && data.crmObjectsData && data.crmObjectsData.total || 0,
    loading,
    error
  };
}
export default useObjectCount;